import * as Sentry from '@sentry/vue'

import {
  captureFeedbackWithAttachments,
  getBeforeBreadcrumb,
  setDeviceContext,
} from './utils/index.js'
import type { SentryInitOptions } from './utils/types.js'

export * from './utils/index.js'

export function init(
  options: SentryInitOptions,
): ReturnType<typeof Sentry.init> {
  if (options.dsn === '') {
    // eslint-disable-next-line no-console
    console.warn(
      '(@collector/shared-plugin-sentry-vue) dsn is empty string, Sentry is not initialized',
    )
    return
  }

  // https://docs.sentry.io/platforms/javascript/configuration/transports/#offline-caching
  const offlineTransport = Sentry.makeBrowserOfflineTransport(
    Sentry.makeFetchTransport,
  )

  const beforeBreadcrumb = options.urlsWithTrackedPayload
    ? getBeforeBreadcrumb(options.urlsWithTrackedPayload)
    : undefined

  setDeviceContext()

  return Sentry.init({
    transport: offlineTransport,
    replaysOnErrorSampleRate: 1,
    beforeBreadcrumb,
    normalizeDepth: 10,
    ...options,
  })
}

export default {
  ...Sentry,
  init,
  captureFeedbackWithAttachments,
} as typeof Sentry & {
  init: typeof init
  captureFeedbackWithAttachments: typeof captureFeedbackWithAttachments
}
